module.exports = __webpack_public_path__ + "static/img/vrRoad_cover_3.2ddff630.png";